<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection copyright">
<p class="noindent_j4">Copyright © 2006 by William Bearden</p>
<p class="noindent_j">ISBN 978-1-6251-7155-9</p>
<p class="noindent_j1">Published by Arcadia Publishing</p>
<p class="noindent_j">Charleston, South Carolina</p>
<p class="noindent_j1">Printed in the United States of America</p>
<p class="noindent_j1">Library of Congress Catalog Card Number: 2005935860</p>
<p class="noindent_j1">For all general information contact Arcadia Publishing at:</p>
<p class="noindent_j">Telephone 843-853-2070</p>
<p class="noindent_j">Fax 843-853-0044</p>
<p class="noindent_j">E-mail <a href="mailto:sales@arcadiapublishing.com">sales@arcadiapublishing.com</a></p>
<p class="noindent_j">For customer service and orders:</p>
<p class="noindent_j">Toll-Free 1-888-313-2665</p>
<p class="noindent_j1">Visit us on the Internet at <a href="http://www.arcadiapublishing.com" target="_blank">www.arcadiapublishing.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?ff4327ae